
import { useEffect, useState } from "react"

import { useParams } from "react-router";

import { Box, Paper, Tabs, Tab, Grid } from "@mui/material"

import { TabProps, TabPanel } from "../../../helpers/TabPanel"

import { Layout } from "../../../components/Layout"
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente"
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator"
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion"
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";

import { Anexos } from "../ui/Anexos";
import { Asistentes } from "../ui/Asistentes";
import { Digitalizar } from "../ui/Digitalizar";
import { Notificacion } from "../ui/Notificacion";
import { AcordarPromociones } from "../ui/AcordarPromociones";
import { InformacionAudiencia } from "../ui/InformacionAudiencia";

import { DetalleAudiencia } from "../../../connections/audiencias/AudienciaConnection";

import { AnexoProps } from "../../../interfaces/comun/AnexoInterface";
import { NotificacionesProps } from "../../../interfaces/notificaciones/NotificacionesInterface";
import { AsistenteProps, AudienciaProps, defaultAudiencia, PromocionesProps } from "../../../interfaces/audiencias/AudienciaInterface";

const edit = false;

export const DigitalizarAnexosPage = () => {

    const { Id } = useParams();

    const [loading, setLoading] = useState( true );

    const [value, setValue] = useState( 0 );

    const [audiencia, setAudiencia] = useState<AudienciaProps>( defaultAudiencia );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [asistentes, setAsistentes] = useState<AsistenteProps[]>( [] );
    const [notificaciones, setNotificaciones] = useState<NotificacionesProps[]>( [] );
    const [anexos, setAnexos] = useState<AnexoProps[]>( [] );
    const [promociones, setPromociones] = useState<PromocionesProps[]>( [] );

    const handleChange = (_: React.SyntheticEvent, newValue: number) => setValue( newValue )

    const handleFinalizar = () => {

        setProcesoTerminado( true );
        setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');

    }

    useEffect(() => {

        async function Obtener() {

            setLoading( true );

            await DetalleAudiencia( Id ?? '' ).then(resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setAudiencia( resp );
                        setAsistentes( resp.asistentes );
                        setNotificaciones( resp.notificaciones );
                        setAnexos( resp.anexos );
                        setPromociones( resp.promociones );

                        if ( resp.idEstatus === 3 ) {

                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( resp.idEstatus === 4 ) {

                            setProcesoCancelado( true );
                            setLoading( false );

                        }
                        else if ( !resp.asignadoMismoUsuario ) {

                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ resp.usuarioAsignado }`);
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 36 ) {

                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 36 ) {
                            setLoading( false );
                        }

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if ( Id ) {
            Obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={[{ text: 'Gestionar audiencia' }, { text: 'Escanear anexo(s)' }]} backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ audiencia.idEstatus === 3 } />
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange }>

                                        <Tab label="Digitalizacion" {...TabProps(0)} />
                                        <Tab label="Información de la audiencia" {...TabProps(1)} />
                                        <Tab label="Asistentes en la audiencia" {...TabProps(2)} />
                                        <Tab label="Notificación" {...TabProps(3)} />
                                        <Tab label="Anexo(s)" {...TabProps(4)} />
                                        <Tab label="Acordar promociones" {...TabProps(5)} />
                                        <Tab label="Información del expediente" {...TabProps(6)} />

                                    </Tabs>

                                </Box>

                                <TabPanel value={ value } index={ 0 }>

                                    <Box p={ 4 } component={ Paper }>

                                        <BoxHeaderInformacion numeroSeguimiento={ `GAU-${ audiencia.idAudiencia }` } fecha={ audiencia?.fecha ?? new Date() } />

                                        <Grid container spacing={ 3 } mt={ 1 }>

                                            <Grid size={ 12 }>

                                                <Digitalizar
                                                    id={ Id ?? '' }
                                                    expediente={ audiencia.expediente }
                                                    callbackFinalizar={ handleFinalizar }
                                                />

                                            </Grid>

                                        </Grid>

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 1 }>

                                    <Box p={ 4 } component={ Paper }>

                                        <InformacionAudiencia
                                            audiencia={ audiencia }
                                            edit={ edit }
                                        />

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 2 }>

                                    <Asistentes
                                        audiencia={ audiencia }
                                        asistentes={ asistentes }
                                        setAsistentes={ setAsistentes }
                                        partes={ audiencia.expediente.partes }
                                        edit={ edit }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 3 }>

                                    <Notificacion
                                        audiencia={ audiencia }
                                        notificaciones={ notificaciones }
                                        setNotificaciones={ setNotificaciones }
                                        edit={ edit }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 4 }>

                                    <Anexos
                                        audiencia={ audiencia }
                                        anexos={ anexos }
                                        setAnexos={ setAnexos }
                                        edit={ edit }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 5 }>

                                    <AcordarPromociones
                                        audiencia={ audiencia }
                                        promociones={ promociones }
                                        setPromociones={ setPromociones }
                                        edit={ edit }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 6 }>

                                    <BoxInformacionExpediente expediente={ audiencia.expediente } />

                                </TabPanel>

                            </>
            }

        </Layout>
    )
}
